let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("86pTb")).then(() => parcelRequire('haHsR'));